export default __webpack_public_path__ + "static/media/mobile-icon.0a68ad6b.png";